import { render, staticRenderFns } from "./draws.vue?vue&type=template&id=13e2c892&scoped=true&"
import script from "./draws.vue?vue&type=script&lang=js&"
export * from "./draws.vue?vue&type=script&lang=js&"
import style0 from "./draws.vue?vue&type=style&index=0&id=13e2c892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2c892",
  null
  
)

export default component.exports